import { ChangeContext, NgxSliderModule, Options } from '@angular-slider/ngx-slider';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, RouterModule } from '@angular/router';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { EMPTY, finalize, mergeMap, tap } from 'rxjs';
import { HeaderService } from 'src/app/services/header.service';
import { BuyerFeedbackForm, FeedbackQuestion, PortalApiService, PropertyDetails, QuestionType } from 'src/app/services/portal-api.service';
import { LanguageRouterLinkDirective } from 'src/app/shared/directives/language-router-link.directive';

@Component({
  selector: 'app-feedback',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslocoDirective,
    NgxSliderModule,
    CommonModule,
    FormsModule,
    RouterModule,
    LanguageRouterLinkDirective
  ],
  templateUrl: './feedback.component.html',
  styleUrl: './feedback.component.css',
  providers: [provideNgxMask()],
})
export class FeedbackComponent {

  public loading = true;

  protected userForm = new FormGroup({});
  protected propertyAddress: string | undefined;

  protected feedbackPending: boolean | undefined = undefined;
  protected feedbackCompleted = false;

  public feedbackQuestions: FeedbackQuestion[] = [];
  protected propertyId: string | undefined;
  protected propertyCode: string | undefined;
  
  private requestId = '';
  private feedbackForm: BuyerFeedbackForm | undefined;
  private optionTranslations = new Map<string, any>();

  public QuestionType = QuestionType;


  constructor(
    private _headerService: HeaderService,
    private _portalApi: PortalApiService,
    private _activatedRoute: ActivatedRoute,
    private _translateService: TranslocoService
  ) {

    this._activatedRoute.params.pipe(
      tap((params: Params) => {
        this.requestId = params['requestId'];
      }
    )).subscribe();
  }

  ngOnInit() {
    this._portalApi.getBuyerFeedbackForm(this.requestId).pipe(
      mergeMap((feedbackForm: BuyerFeedbackForm) => {
        this.feedbackPending = feedbackForm.isPending ?? false;
        this.propertyId = feedbackForm.propertyId;
        this.feedbackForm = feedbackForm;

        if (this.propertyId) {
          return this._portalApi.getPropertyByIdUnmasked(this.propertyId)
        } else {
          return EMPTY
        }
      }),
      tap((res: PropertyDetails) => {
        this.propertyCode = res.code;
        this.propertyAddress = `${res.address?.streetName} ${res.address?.streetNumber}, ${res.address?.prefecture}`;
      }),
      finalize(() => {
        if (this.feedbackPending) {
          this._headerService.setAltNavigation('Υποβολή σχολίων', undefined);
          this.feedbackQuestions = this.feedbackForm?.questions ?? [];
          this.initFeedbackForm();
        }
        this.loading = false;
      })
    ).subscribe();
  }

  onSubmit() {
    this.mapFormToFeedback();
    this._portalApi.submitBuyerFeedback(this.requestId, this.feedbackQuestions).pipe(
      tap(() => {
        this.feedbackCompleted = true;
        this.feedbackPending = false;
        
        this._headerService.removeAltNav();
      })
    ).subscribe();
  }

  public onSelectOption(optionCode: string | undefined, control: string | undefined) {
    if (control) {
      this.userForm.get(control)?.setValue(optionCode);
      
      // TODO: Review - Commented out because single select has been applied for crm integration
      // let selectedOptions = this.userForm.get(control+'SelectedOptionCodes')?.value;

      // if (!selectedOptions?.includes(optionCode)) {
      //   selectedOptions.push(optionCode);
      // } else {
      //   selectedOptions = selectedOptions?.filter((x: string) => { return x !== optionCode });
      // }

    //this.userForm.get(control+'SelectedOptionCodes')?.setValue(selectedOptions);
    }

  }

  private initFeedbackForm() {
    const group: any = {};

    this.feedbackQuestions?.forEach((question) => {
      if (question.code) {
        group[question.code] = new FormControl<string | undefined>(undefined);

        // TODO: Review - Commented out because single select has been applied for crm integration
        if (question.type === QuestionType.Select) {
          //group[question.code + 'SelectedOptionCodes'] = new FormControl<string[]>([]);

          this._translateService.selectTranslateObject('feedback.user.answer.' + question.code).pipe(
            tap((translations) => {
              this.optionTranslations.set(question.code!, translations);
            })
          ).subscribe();
        }
      }
    });

    this.userForm = new FormGroup(group);
  }

  private mapFormToFeedback() {
    this.feedbackQuestions?.forEach((question) => {
      if (question.code) {
        question.value = this.userForm.get(question.code)?.value;
      }
      // TODO: Review - Commented out because single select has been applied for crm integration
      // if (question.code) {
      //   if (question.followup == null) {
      //     question.value = this.userForm.get(question.code)?.value;
      //   } else {
      //     if (this.userForm.get(question.followup)?.value <= '2') {
      //       let translatedOptions = this.userForm.get(question.code+'SelectedOptionCodes')?.value.map((x: string) => { return this.optionTranslations.get(question.code ?? '')[x] });
      //       question.value = translatedOptions.join(',');
      //     }
      //   }
      // }
    })
  }
}
